import { useDispatch } from 'react-redux'
import { setCurrentSetupSystemData } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'
import CreateJobInput from '../CreateJob/CreateJobInput'

function CommonSystemSetupInput({
  id,
  label = 'Name',
  placeholder = 'Enter Name',
  required = true,
  fullSize = false,
  fieldName = 'name',
}) {
  const dispatch = useDispatch()

  const { currentSystemSetupData } = useSelector((store) => store.recruitment)

  console.log(currentSystemSetupData?.value, 'leart18')

  return (
    <CreateJobInput
      id={id}
      placeholder={placeholder}
      label={label}
      required={required}
      fullSize={fullSize}
      value={currentSystemSetupData?.value}
      onChange={(value, required) =>
        dispatch(
          setCurrentSetupSystemData({ field: fieldName, value, required })
        )
      }
    />
  )
}

export default CommonSystemSetupInput
